import React from "react";
import { motion } from "framer-motion";

const SkillBar = ({ label, width, percent, delay = 0.5 }) => (
    <div className="overflow-x-hidden">
        <p className="text-sm uppercase font-medium">{label}</p>
        <span className="w-full h-2 bgOpacity rounded-md inline-flex mt-2">
      <motion.span
          initial={{ x: "-100%", opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.5, delay }}
          className={`${width} h-full bg-gradient-to-r from-blue-600 via-pink-500 to-red-500 rounded-md relative`}
      >
        <span className="absolute -top-7 right-0">{percent}</span>
      </motion.span>
    </span>
    </div>
);

const Skills = () => {
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 0.5 } }}
            className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
        >
            {/* LEFT COLUMN */}
            <div className="w-full lgl:w-1/2">
                <div className="py-12 font-titleFont flex flex-col gap-4">
                    <p className="text-sm text-designColor tracking-[4px] uppercase">
                        QA Automation
                    </p>
                    <h2 className="text-3xl md:text-4xl font-bold">
                        Testing & Frameworks
                    </h2>
                </div>

                <div className="mt-14 w-full flex flex-col gap-6">
                    <SkillBar label="Selenium" width="w-[95%]" percent="95%" />
                    <SkillBar label="Playwright" width="w-[85%]" percent="85%" />
                    <SkillBar label="Cypress" width="w-[85%]" percent="85%" />
                    <SkillBar label="Serenity BDD (Screenplay)" width="w-[95%]" percent="95%" />
                    <SkillBar label="Serenity JS" width="w-[80%]" percent="80%" />
                    <SkillBar label="Appium (Mobile Automation)" width="w-[75%]" percent="75%" />
                    <SkillBar label="API Testing (REST / Postman)" width="w-[90%]" percent="90%" />
                    <SkillBar label="Postman Collections" width="w-[85%]" percent="85%" />
                    <SkillBar label="Test Automation Architecture" width="w-[90%]" percent="90%" />
                    <SkillBar label="Cross-browser & Cross-device Testing" width="w-[85%]" percent="85%" />
                </div>
            </div>

            {/* RIGHT COLUMN */}
            <div className="w-full lgl:w-1/2">
                <div className="py-12 font-titleFont flex flex-col gap-4">
                    <p className="text-sm text-designColor tracking-[4px] uppercase">
                        Engineering
                    </p>
                    <h2 className="text-3xl md:text-4xl font-bold">
                        CI/CD, Performance & Cloud
                    </h2>
                </div>

                <div className="mt-14 w-full flex flex-col gap-6">
                    <SkillBar label="CI/CD (Jenkins, GitHub Actions, Azure DevOps)" width="w-[85%]" percent="85%" />
                    <SkillBar label="BDD (Cucumber / Gherkin)" width="w-[95%]" percent="95%" />
                    <SkillBar label="Performance Testing (k6)" width="w-[80%]" percent="80%" />
                    <SkillBar label="Performance Testing (JMeter)" width="w-[75%]" percent="75%" />
                    <SkillBar label="Monitoring & Dashboards (Grafana)" width="w-[70%]" percent="70%" />
                    <SkillBar label="Cloud Platforms (AWS)" width="w-[80%]" percent="80%" />
                    <SkillBar label="Cloud Platforms (Azure)" width="w-[70%]" percent="70%" />
                    <SkillBar label="Version Control (Git / GitHub)" width="w-[85%]" percent="85%" />
                    <SkillBar label="Agile / Scrum Collaboration" width="w-[95%]" percent="95%" />
                    <SkillBar label="Quality Strategy & Risk-based Testing" width="w-[90%]" percent="90%" />
                </div>
            </div>
        </motion.div>
    );
};

export default Skills;
